import React from "react";
import Dashboard from "../../UI/dashboard";

export default () => <Dashboard />;
